import { useTranslation } from 'react-i18next';
import { MarketingCardContent } from '../HostfullyAssistMarketing.constants';
import {
  CardDescription,
  CardIcon,
  CardTitle,
  MarketingCard,
} from '../HostfullyAssistMarketing.styles';

interface MarketingContentCardProps {
  background: string;
  card: MarketingCardContent;
}

const MarketingContentCard = ({
  background,
  card,
}: MarketingContentCardProps) => {
  const { t } = useTranslation();
  const { Icon, titleKey, descriptionKey, testId } = card;

  return (
    <MarketingCard data-testid={testId} $background={background}>
      <CardIcon>
        <Icon aria-hidden />
      </CardIcon>
      <CardTitle>{t(titleKey)}</CardTitle>
      <CardDescription>{t(descriptionKey)}</CardDescription>
    </MarketingCard>
  );
};

export default MarketingContentCard;
